<h2 mat-dialog-title>Move Case to {{selectedAccount.accountName}}</h2>
<mat-dialog-content>
  <form [formGroup]="moveCaseForm">
    <mat-form-field style="width:100%">
      <mat-label>Case</mat-label>
      <mat-select formControlName="case" *ngIf="cases" (selectionChange)="getCaseInfo()">
        <cdk-virtual-scroll-viewport [itemSize]="20" style="height:256px">
          <mat-option *cdkVirtualFor="let case of cases" [value]="case.caseId" [style.height.px]="40">
            <div>{{case.caseName}}</div>
          </mat-option>
        </cdk-virtual-scroll-viewport>
      </mat-select>
    </mat-form-field>
  </form>
  <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: row; margin: 10px" *ngIf="selectedCase">
    <div style="flex: 1 1 0%; box-sizing: border-box;">
      <div>
        <div>
          <mat-label class="title">Simple Case Id</mat-label>
        </div>
        <div style="margin-top: 10px;">{{selectedCase.simpleCaseId}}</div>
      </div>
    </div>
    <div style="flex: 1 1 0%; box-sizing: border-box;">
      <div>
        <div>
          <mat-label class="title">Current Account</mat-label>
        </div>
        <div style="margin-top: 10px;">{{selectedCase.account.accountName}}</div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
  <button mat-raised-button color="primary" id="submitMoveCaseForm" [disabled]="moveCaseForm.pristine" (click)="moveCaseToAccount()">Move Case</button>
  <button mat-raised-button color="secondary" mat-dialog-close>Cancel</button>
</mat-dialog-actions>
